export default __webpack_public_path__ + "static/media/receive.a0fb21ef.mp3";